import React, {  useState, useEffect } from 'react';
import moment from "moment";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { getRandomBackgroundColor } from '../../../../utils/commonFunctions';
import '../../../../assets/styles/styles.scss';


const localizer = momentLocalizer(moment);
moment.locale("en-GB");

const MenuCalendar=(props)=>{

  const [state,setState]=useState({menu:[],navCount:0, key:getRandomBackgroundColor(), currentView: 'month',allViews:["day","month"],selectedMenu:{}})
  const getStartDate = (dt) => {
    if (!dt) return new Date();
    const parts = dt.split("T")[0].split("-").map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0);
  };

  const getEndDate = (dt) => {
    if (!dt) return new Date();
    const parts = dt.split("T")[0].split("-").map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
  };

  useEffect(() => {
    if (props.data?.mealMenu) {
      setState((prev) => ({
        ...prev,
        mealPlan: props.data.mealMenu,
        menu: props.data.mealMenu.map((fl) => ({
          id: fl._id,
          title: `${fl.menuPlanName}-${(fl.status || 'Active').charAt(0).toUpperCase() + (fl.status || 'Active').slice(1)}`,
          start: getStartDate(fl.fromDate),
          end: getEndDate(fl.toDate),
          bgColor: fl.statusColorCode || '#03b451'
        })),
        key: props.data?.defaultDate ? props.data.defaultDate.getTime() : prev.key
      }));
    }
  }, [props.data?.mealMenu, props.data?.defaultDate]);

  const handleSelect = () => {};

  const viewMenuDetails = (m) => {
    if (m) {
      const selectedMealPlan = props.data?.mealMenu.find(meal => meal._id === m.id);
      if (selectedMealPlan) {
        props.actions(selectedMealPlan, 'viewMenuPlan');
      }
    }
  };

  const MyToolbar = (toolbar) => {
    const goToBack = () => {
      toolbar.onNavigate('PREV');
    };

    const goToNext = () => {
      toolbar.onNavigate('NEXT');
    };

    const goToToday = () => {
      toolbar.onNavigate('TODAY');
    };

    return (
      <div className="rbc-toolbar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', marginBottom: '15px' }}>
        <span className="rbc-btn-group" style={{ display: 'inline-flex', alignItems: 'center' }}>
          <button type="button" className="nav-button" onClick={goToBack} style={{ padding: '6px 14px', background: '#1c2b40', border: '0.7px solid #ffffff', borderRight: 'none', color: '#fff', borderRadius: '4px 0 0 4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}>
            &lt;
          </button>
          <button type="button" className="nav-button" onClick={goToToday} style={{ padding: '6px 14px', background: '#1c2b40', border: '0.7px solid #ffffff', borderRight: 'none', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
            This Month
          </button>
          <button type="button" className="nav-button" onClick={goToNext} style={{ padding: '6px 14px', background: '#1c2b40', border: '0.7px solid #ffffff', color: '#fff', borderRadius: '0 4px 4px 0', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}>
            &gt;
          </button>
        </span>

        <span className="rbc-toolbar-label" style={{ fontSize: '22px', fontWeight: '700', color: '#ffffff', textAlign: 'center' }}>
          {toolbar.label}
        </span>

        <span className="rbc-btn-group right">
          <button type="button" className="nav-button" onClick={goToToday} style={{ padding: '6px 18px', background: '#1c2b40', border: '0.7px solid #ffffff', color: '#fff', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
            Today
          </button>
        </span>
      </div>
    );
  };

  const formats = {
    dayFormat: (date, culture, localizer) =>
      localizer.format(date, 'ddd', culture),
  };

  const eventPropGetter = (event, start, end, isSelected) => {
    const style = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: event.bgColor,
      color: 'white',
      overflowY: 'auto',
      fontWeight: '700',
      fontSize: '14px',
      maxHeight: '40px',
    };
    return { style };
  };

  return (
    <div className='container-fluid dashboard-summary-container' style={{ height: '80vh', overflowY: 'scroll' }}>
      <Calendar
        localizer={localizer}
        key={props.data?.defaultDate ? props.data.defaultDate.getTime() : state.key}
        views={state.allViews}
        selectable
        defaultView={state.currentView}
        onSelectEvent={(event) => viewMenuDetails(event)}
        onSelectSlot={handleSelect}
        eventPropGetter={eventPropGetter}
        components={{ toolbar: MyToolbar }}
        formats={formats}
        style={{
          pointerEvents: props.data?.isOpenMenu ? 'none' : 'auto',
          filter: props.data?.isOpenMenu ? 'blur(2px)' : 'none',
          height: '80vh',
          overflowY: 'auto',
        }}
        date={props.data?.defaultDate || new Date()}
        onNavigate={(newDate, view, action) => {
          if (newDate && props.onDateChange) {
            props.onDateChange(newDate, action);
          }
        }}
        events={state.menu}
      />
    </div>
  );
}

export default MenuCalendar;